<template>
  <nav>
    <LcHeader headline-class="text-uppercase" @left-button-click="$emit('left-button-click')">
      <template v-if="title" #headline>
        <ScratchcardTitle v-bind="{ color, title }" />
      </template>

      <template v-else #headline>
        <LcSkeleton height="1.625rem" radius="large" />
      </template>

      <template v-if="showMenu" #right>
        <LcMenuButton
          v-bind="{ options }"
          v-model:value="displayModeModel"
          icon="more-horizontal"
          placement="bottom-start"
        />
      </template>
    </LcHeader>
  </nav>
</template>

<script lang="ts" setup>
import type { LcMenuButtonOption } from '@lottocom/frontend-components'

import { SCRATCHCARD_DISPLAY_MODES, type ScratchcardDisplayMode } from './types'

type ScratchcardMyOrdersHeaderEmits = {
  (e: 'left-button-click'): void
}

type ScratchcardMyOrdersHeaderProps = {
  color?: string
  showMenu?: boolean
  title?: string
}

defineEmits<ScratchcardMyOrdersHeaderEmits>()

defineProps<ScratchcardMyOrdersHeaderProps>()

const displayModeModel = defineModel<ScratchcardDisplayMode>('displayMode')

const { t } = useI18n()

const options: LcMenuButtonOption<ScratchcardDisplayMode>[] = [
  {
    icon: 'scratch-scratched',
    label: t('myorders.detail.scratchcard.displaymodemenu.button.frontscratched.title'),
    value: SCRATCHCARD_DISPLAY_MODES.FRONT_SCRATCHED,
  },
  {
    icon: 'scratch-unscratched',
    label: t('myorders.detail.scratchcard.displaymodemenu.button.frontunscratched.title'),
    value: SCRATCHCARD_DISPLAY_MODES.FRONT_UNSCRATCHED,
  },
  {
    icon: 'scratch-backside',
    label: t('myorders.detail.scratchcard.displaymodemenu.button.backside.title'),
    value: SCRATCHCARD_DISPLAY_MODES.BACKSIDE,
  },
]
</script>
